var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 39,
    viewBox: "0 0 75 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0089 5.71801C56.9324 31.893 28.8131 42.5345 2.69646 27.7987C1.82703 27.308 0.724491 27.6147 0.233807 28.4734C-0.256877 29.3475 0.0498334 30.4515 0.919265 30.9422C28.9128 46.7514 59.1037 35.4811 74.1922 7.4354C74.6645 6.56137 74.3348 5.45718 73.4562 4.98183C72.5776 4.52181 71.4812 4.84398 71.0089 5.71801Z",
    fill: "#C5D4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 16.5728C27.5808 16.5728 29.9381 14.2156 29.9381 11.3079C29.9381 8.40015 27.5808 6.043 24.6731 6.043C21.7654 6.043 19.4082 8.40015 19.4082 11.3079C19.4082 14.2156 21.7654 16.5728 24.6731 16.5728Z",
    fill: "#C5D4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4706 10.9722C49.3215 10.9722 51.6327 8.6611 51.6327 5.81019C51.6327 2.95928 49.3215 0.648193 46.4706 0.648193C43.6197 0.648193 41.3086 2.95928 41.3086 5.81019C41.3086 8.6611 43.6197 10.9722 46.4706 10.9722Z",
    fill: "#C5D4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.4c8f41a2cf6cf7b0e536a50a1852da04.svg";
export { ForwardRef as ReactComponent };